/**
 * Open a PDF file preview in new browser tab
 */
export const openPdfPreview = (pdfData) => {
    const blob = new Blob([pdfData], { type: "application/pdf" });
    const file = new File([blob], "preview", { type: "application/pdf" });
    const fileUrl = URL.createObjectURL(file);
    window.open(fileUrl, "_blank");
    // const url = URL.createObjectURL(blob);
    // window.open(url, "_blank");
    // setTimeout(() => URL.revokeObjectURL(url), 1000);
};
